import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getNestedProperty } from '../../helpers/getNestedProperty';
import { StatusInputWrapper } from '../StatusInputWrapper';

const StreetAddress = ({ t, label, reduxAppProperty, changeObjectPropertyAction, validateStreetAddress, streetAddressError, streetAddressValid, setIsError }) => {
  // const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const streetAddress = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).streetAddress)

  const handleStreetAddress = (e) => {
    try {
      let name = e.currentTarget.value
      changeObjectPropertyAction('streetAddress', name);
      validateStreetAddress(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurStreetAddress = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      changeObjectPropertyAction('streetAddress', name);

      validateStreetAddress(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }



  return (
    <StatusInputWrapper
      isValid={streetAddressValid}
      errorMsg={streetAddressError}
      t={t}
      label={label ?? t('mailing_address.street_address')}
      isFocussed={isFocussed}
      id="StreetAddress"
      name="StreetAddress"
      type="text"
      customClasses={'fw-20'}
      aria-describedby="street-address"
      onChange={handleStreetAddress}
      onBlur={onBlurStreetAddress}
      onFocus={() => SetIsFocussed(true)}
      value={streetAddress}
      autoComplete="off"
      maxLength="50"
    />
  )
}

export default withTranslation('common')(StreetAddress)